<template>
    <Dialog
        v-model:visible="modalStore.isOpen"
        modal
        :header="$t(modalStore.title) || ' '"
        :style="style"
        :breakpoints="breakpoints"
    >
        <component :is="component" />
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog'
import modalComponents from '@/components/modalComponents.js'
import { useModalStore } from '@/stores/modal.js'

export default {
    name: 'Modal',

    components: {
        Dialog,
    },

    data() {
        return {
            modalComponents,
            modalStore: useModalStore(),
        }
    },

    computed: {
        modalName() {
            return this.modalStore.name
        },

        width() {
            if (this.modalStore.fixSize) return `${this.modalStore.fixSize}px`
            if (this.modalStore.size === 'xlarge') return '90vw'
            if (this.modalStore.size === 'large') return '50vw'
            if (this.modalStore.size === 'small') return '30vw'
            return '40vw'
        },

        style() {
            return {
                width: this.width,
            }
        },

        component() {
            return modalComponents[this.modalName]
        },

        breakpoints() {
            if (this.modalStore.fixSize) {
                return {}
            }
            return {
                '1024px': '95vw',
            }
        },
    },
}
</script>
